export const GoldenArc = ({ className = "", flip = false }) => (
    <svg
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
        className={className}
        style={flip ? { transform: "scaleY(-1)" } : undefined}
        aria-hidden="true"
    >
        <defs>
            <linearGradient id="cajusp-arc-gold" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0" stopColor="#8C6D35" stopOpacity="0" />
                <stop offset="0.5" stopColor="#C9A765" />
                <stop offset="1" stopColor="#8C6D35" stopOpacity="0" />
            </linearGradient>
        </defs>
        <path
            d="M-20 108 Q 720 8 1460 96"
            fill="none"
            stroke="url(#cajusp-arc-gold)"
            strokeWidth="1.4"
        />
    </svg>
);
